<template>
  <div id="productDetail">
    <div class="overlay" v-if="showLoading">
      <div div style="position:fixed;
          top: 50%;
          left: 50%;
          z-index:999999">
        <vue-loaders-ball-spin-fade-loader color="#173B6B" scale="1.5">
        </vue-loaders-ball-spin-fade-loader>
      </div>
    </div>
    <span class="titleConceptProduct">{{conceptProductTitleName}}</span>
    <!-- <span :class="form1Detail.latest_update=='ตรวจแล้ว'? 'adminLatestUpdate':'smeLatestUpdate'"
    v-if="form1Detail.latest_update">
      ({{form1Detail.latest_update}})
    </span> -->
    <ConceptProductDetail></ConceptProductDetail>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ConceptProductDetail from '../components/ConceptProduct/ConceptProductDetail.vue';

export default {
  components: {
    ConceptProductDetail,
  },
  async created() {
    const { id } = this.$route.params;
    await this.$store.dispatch('ConceptProduct/clearState');
    await this.$store.dispatch('ConceptProduct/getConceptProductDetail', id);
  },
  computed: {
    ...mapGetters('ConceptProduct', ['conceptProductDetail', 'showLoading']),
    ConceptProductName() {
      return this.conceptProductDetail.name;
    },
  },
  watch: {
    ConceptProductName() {
      if (this.conceptProductDetail.name !== null && this.conceptProductDetail.name !== ''
        && this.conceptProductDetail.name !== undefined) {
        const trimTitle = this.conceptProductDetail.name.trim();
        if (trimTitle.length !== 0) {
          this.conceptProductTitleName = this.conceptProductDetail.name;
        } else {
          this.conceptProductTitleName = 'ชื่อแนวคิดผลิตภัณฑ์';
        }
      } else {
        this.conceptProductTitleName = 'ชื่อแนวคิดผลิตภัณฑ์';
      }
    },
  },
  data() {
    return {
      conceptProductTitleName: 'ชื่อแนวคิดผลิตภัณฑ์',
    };
  },
};
</script>

<style>
  .titleConceptProduct {
    font-size: 30px;
    color: #173B6B;
  }
  .adminLatestUpdate {
    margin-left: 30px;
    color: #28a745;
  }
  .smeLatestUpdate {
    margin-left: 30px;
    color: red;
  }
  #productDetail {
    padding-left: 20px;
  }
  .overlay {
    background-color:#EFEFEF;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1;
    top: 0px;
    left: 0px;
    opacity: 0.3;
  }
</style>
